module.exports = __webpack_public_path__ + "img/pc-foreground.67a39c31.webp";